<template>
  <modal-form v-model="show" size="sm" :key="bureau"
    :show-submit="false" text-close="Fechar"
    body-class="pa-0"
  >
    <template slot="title">
      Detalhes de faturamento
    </template>
    <template slot="body">
      <core-grid
        ref="grid"
        class="ma-3"
        modal flat
        hide-all-options
        :onRead="onRead"
        :schema="schema"
      />
    </template>
  </modal-form>
</template>

<script>
export default {
  data () {
    return {
      show: false,
      model: {},
      bureau: '',
      schema: [
        {
          text: 'Periodo',
          align: 'start',
          value: 'Periodo',
        },
        { text: 'Quantidade Total', value: 'QuantidadeTotalPeriodo' },
        { text: 'Tipo Consulta', value: 'Criterio[0].Nome' },
        { format: 'button', action: this.enviarDetalhamento, icon: 'ph-envelope', tooltip: 'Enviar detalhamento por email', width: '25', }
      ],
    };
  },
  methods: {
    openModal (sender, bureau) {
      const th = this
      th.$set(th, 'bureau', bureau)
      const formatPeriodo = sender.map(obj => {
        const periodo = th.$api.UI.Format.Date(obj.Periodo, 'MM/yyyy');
        return { ...obj, Periodo: periodo };
      });
      th.$set(th, 'model', formatPeriodo)
      th.show = true
    },
    onRead (options) {
      const th = this;
      options.success(th.model)
    },
    enviarDetalhamento (event, current) {
      event.preventDefault()
      const th = this;
      const periodo = current.Periodo.split('/')

      var dto = {
        parms: [
          { name: 'Periodo', value: `${periodo[1]}-${periodo[0]}` },
          { name: 'Nome', value: th.$api.Estruturadas.bureaus.find(p => p.text === th.bureau).value },
          { name: 'DocumentoParceiro', value: th.$api.UI.Format.SomenteNumeros(th.$empresa.documentoFederal) },
        ]
      }

      th.$api.Multiplo.Post('EnviarLogDeUsoDetalhe', dto).then(response => {
        if (th.$api.UI.PostLoadData(response, true)) {
          this.$api.UI.ShowSuccess('Sucesso', 'E-mail com detalhamento enviado!')
        }
      });
    }
  }
};
</script>
